export function RecurringNotifBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;

  return joint.shapes.html.AbstractBoxElementView.extend({
    isElementEditable: true,

    editElementModalController: [
      '$scope',
      '$mdDialog',
      'elementData',
      'context',
      ($scope, $mdDialog, elementData) => {
        $scope.elementData = elementData;
        $scope.context = context;
        $scope.cancelDialog = $mdDialog.cancel;
        $scope.hideDialog = $mdDialog.hide;
      },
    ],
    editElementModalTemplate: `<angular-recurring-notif
      [context]="context"
      [element-data]="elementData"
      (hide-dialog)="hideDialog($event)"
      (cancel-dialog)="cancelDialog()"
      ></angular-recurring-notif>`,

    angularTemplate: require('./RecurringNotifBoxView.html'),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      this.updatePictureUrl();
    },

    afterEditElement: function () {
      this.updatePictureUrl();
    },

    updatePictureUrl: function () {
      if (this.angularScope.elementData?.pictureId) {
        this.angularScope.pictureUrl = services.MediasFactory.pictureUrl(
          context.companyId,
          this.angularScope.elementData.pictureId
        );
      }
    },
  });
}
